import axios from 'axios';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export function pushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export function pushGranted() {
  return pushSupported() && Notification.permission === 'granted';
}

export async function enablePush(API) {
  if (!pushSupported()) throw new Error('unsupported');
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('denied');
  const reg = await navigator.serviceWorker.ready;
  const { data } = await axios.get(`${API}/push/vapid-public-key`);
  const key = data.public_key;
  if (!key) throw new Error('no-key');
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(key),
    });
  }
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  await axios.post(
    `${API}/push/subscribe`,
    { subscription: sub.toJSON() },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return true;
}
